
import React from "react";
import { LoginPage } from "./LoginPage";

export const SupabaseLoginPage: React.FC = () => {
  return <LoginPage />;
};
